"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var OptimalMarginGraphData_1 = require("../model/OptimalMarginGraphData");

var OptimalMarginGraphDataConverter_1 = require("./OptimalMarginGraphDataConverter");
/**
 * @author Jaroslav Sevcik
 */


var OptimalMarginGraphDataConverterImpl =
/*#__PURE__*/
function (_OptimalMarginGraphDa) {
  _inherits(OptimalMarginGraphDataConverterImpl, _OptimalMarginGraphDa);

  function OptimalMarginGraphDataConverterImpl() {
    _classCallCheck(this, OptimalMarginGraphDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimalMarginGraphDataConverterImpl).apply(this, arguments));
  }

  _createClass(OptimalMarginGraphDataConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        optimizationGoal: source.optimizationGoal,
        margin: source.margin
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new OptimalMarginGraphData_1.OptimalMarginGraphData(conversions.asObject(source, 'optimizationGoal', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'margin', function (v) {
        return index_1.Utils.asNumber(v);
      }));
    }
  }]);

  return OptimalMarginGraphDataConverterImpl;
}(OptimalMarginGraphDataConverter_1.OptimalMarginGraphDataConverter);

exports.OptimalMarginGraphDataConverterImpl = OptimalMarginGraphDataConverterImpl;